import { formatDate } from '@angular/common';
import {
ChangeDetectionStrategy,
ChangeDetectorRef,
Component,
ElementRef,
Input,
OnDestroy,
OnInit,
ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject,combineLatest,Observable,Subject,Subscription } from 'rxjs';
import {
distinctUntilChanged,
filter,
map,
shareReplay,
startWith,
switchMap,
take,
tap,
withLatestFrom
} from 'rxjs/operators';
import { CommissionMeta,ContractMeta } from 'src/app/helper/page-metadata';
import { ContractEntity } from '../../../dave-data-module/entities/mdqx/contract.entity';
import { ContractParticipantResolver } from '../../../dave-data-module/guards/mdqx/contract-participant.resolver';
import { ContractResolver } from '../../../dave-data-module/guards/mdqx/contract.resolver';
import {
MutationCreateContractParticipantArgs,
MutationDeleteContractParticipantArgs
} from '../../../dave-data-module/mdqx-graphql-types';
import { State } from '../../../dave-data-module/State';
import {
DeleteContractParticipantRequest,
PostContractParticipantRequest
} from '../../../dave-data-module/State/actions/mdqx/contract-participant.actions';
import { getCustomerById } from '../../../dave-data-module/State/selectors/customers.selectors';
import {
getContractParticipantsByCustomerId,
getContracts,
getContractsByCustomerId
} from '../../../dave-data-module/State/selectors/mdqx/selectors';
import { isNotNullOrUndefined } from '../../../helper/helper';
import {
SelectContractsForCustomerDialogComponent,SelectContractsForCustomerDialogData
} from '../contract/select-contracts-for-customer-dialog/select-contracts-for-customer-dialog.component';

type TableRow = {
    number: number;
    name: string;
    enteryDate: string;
}


@Component({
    selector: 'app-customer-contract-list-card',
    templateUrl: './customer-contract-list-card.component.html',
    styleUrls: ['./customer-contract-list-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerContractListCardComponent implements OnInit, OnDestroy {
    @ViewChild('contractSearchInput') private contractSearchInput?: ElementRef<HTMLInputElement>;
    @ViewChild('contractSearchInputEdit') private contractSearchInputEdit?: ElementRef<HTMLInputElement>;

    @Input()
    get Editing(): boolean {
        return this.editing;
    }
    set Editing(editing: boolean) {
        // ausgebaut da das anpassen der Verträge jetzt über SelectContractPopupComponent realisiert wird
        // if (editing) {
        //     this.editContractIdList = this.CustomerContractList?.map(c => c.Id);
        // }
        // this.editing = editing;
    }
    private editing = false;
    private customerId$ = new BehaviorSubject<number|null>(null);
    @Input() set CustomerId(v: number) {
        this.customerId$.next(v);
    };
    @Input() private save$: Observable<void>;

    private editContractIdList: number[] = null;
    private allContractsList: ContractEntity[] = null;
    private subscriptions: Subscription[] = [];

    public Loading$ = new BehaviorSubject(true);
    public CustomerContractList: ContractEntity[] = null;
    public OpenContractSelect$ = new Subject<void>();
    public ContractSearchBarActive = false;
    public ContractSearchForm = new FormControl('');
    public ShownCustomerContractsList: ContractEntity[] = [];
    public ShownCustomerContractsList$: Observable<{date: string, name: string, number: string, id: number, ausnahmedatum: string}[]> = this.customerId$.pipe(
            filter(isNotNullOrUndefined),
            distinctUntilChanged(),
            switchMap(customerId => combineLatest([
                this.store.select(getContractsByCustomerId, customerId).pipe(filter(isNotNullOrUndefined)),
                this.store.select(getContractParticipantsByCustomerId, customerId).pipe(filter(isNotNullOrUndefined)),
            ])),
            map(
                ([c, cp], ) =>
                    c.slice().sort((a, b) => {
                        if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                            return -1;
                        }
                        return 1;
                    }).map((c,) => {
                        var cpfiltered = cp.find(p => p.ContractId === c.Id);
                        const date = cpfiltered?.EntryDate;
                        const endDate = cpfiltered?.EndDate;
                        const ausnahmeDatum = cpfiltered?.Ausnahmedatum;
                        return {
                            name: c.Name,
                                number: c.Number,
                            date: date && endDate ? formatDate(date, 'shortDate', 'de-DE')+" - "+formatDate(endDate, 'shortDate', 'de-DE') : date ? "ab "+ formatDate(date, 'shortDate', 'de-DE'): endDate ? "bis "+ formatDate(endDate, 'shortDate', 'de-DE') :  '',
                            ausnahmedatum: ausnahmeDatum ? formatDate(ausnahmeDatum, 'shortDate', 'de-DE') : '',
                            id: c.Id,
                        }
                    }),
            ),
            switchMap((data,) => this.ContractSearchForm.valueChanges.pipe(startWith(null), map(() => {
                const searchTerm = this.ContractSearchForm.value;
                return data.filter((contract) => (contract.name && contract.name.toLowerCase().includes(searchTerm)) || (contract.number && contract.number.toLowerCase().includes(searchTerm)));
            }))),
            shareReplay({refCount: true, bufferSize: 1})
        );
    public ShownAllContractsList: ContractEntity[] = [];
    public ContractMeta = ContractMeta;
    constructor(
        private cdr: ChangeDetectorRef,
        private store: Store<State>,
        private dialog: MatDialog,
        contractResolver: ContractResolver,
        contract2CustomerResolver: ContractParticipantResolver,
        private route: ActivatedRoute,
    ) {
        const customer$ = route.paramMap.pipe(
            map((paramMap) => +paramMap.get('customerId')),
            switchMap((customerId) =>
                store.select(getCustomerById({ id: customerId })).pipe(
                    tap((customer) => !customer && console.error('Could not find Customer')),
                    filter(isNotNullOrUndefined),
                ),
            ),
            shareReplay(1),
        );
        this.subscriptions.push(
            combineLatest([contractResolver.resolve(), contract2CustomerResolver.resolve()])
                .pipe(tap(() => this.Loading$.next(false)))
                .subscribe(),
            this.OpenContractSelect$.pipe(
                withLatestFrom(customer$),
                tap(([, customer]) => {
                    this.dialog.open<SelectContractsForCustomerDialogComponent, SelectContractsForCustomerDialogData>(SelectContractsForCustomerDialogComponent, {
                        ...SelectContractsForCustomerDialogComponent.DefaultConfig,
                        data: {
                            customerId: customer.Id,
                        },
                    });
                }),
            ).subscribe(),
            this.store
                .select(getContracts)
                .pipe(
                    tap(c => (this.allContractsList = c)),
                    tap(() => this.CustomerContractList && this.SearchContract()),
                )
                .subscribe(),
            this.store
                .select(getContracts)
                .pipe(
                    filter(isNotNullOrUndefined),
                    take(1),
                    tap(
                        c =>
                            (this.ShownAllContractsList = c.slice().sort((a, b) => {
                                if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                                    return -1;
                                }
                                return 1;
                            })),
                    ),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.save$
                .pipe(
                    withLatestFrom(this.store.select(getContractParticipantsByCustomerId, this.customerId$.value)),
                    tap(([, contract2customer]) => {
                        const removeContractIds = this.CustomerContractList.filter(
                            c => this.editContractIdList.find(ec => ec === c.Id) === undefined,
                        ).map(c => c.Id);
                        const removeParticipants = contract2customer.filter(p =>
                            removeContractIds.find(c => c === p.ContractId),
                        );
                        const addContractIds = this.editContractIdList.filter(
                            ec => this.CustomerContractList.find(c => c.Id === ec) === undefined,
                        );

                        for (const participant of removeParticipants) {
                            const deleteContractParticipantArgs: MutationDeleteContractParticipantArgs = {
                                id: participant.Id,
                            };
                            this.store.dispatch(new DeleteContractParticipantRequest(deleteContractParticipantArgs));
                        }
                        for (const contractId of addContractIds) {
                            const createContractParticipantArgs: MutationCreateContractParticipantArgs = {
                                contractId,
                                customerId: this.customerId$.value,
                            };
                            this.store.dispatch(new PostContractParticipantRequest(createContractParticipantArgs));
                        }
                    }),
                )
                .subscribe(),
            this.store
                .select(getContractsByCustomerId, this.customerId$.value)
                .pipe(
                    filter(isNotNullOrUndefined),
                    tap(
                        c =>
                            (this.CustomerContractList = c.slice().sort((a, b) => {
                                if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                                    return -1;
                                }
                                return 1;
                            })),
                    ),
                    tap(() => this.allContractsList && this.SearchContract()),
                )
                .subscribe(),
            this.store
                .select(getContractsByCustomerId, this.customerId$.value)
                .pipe(
                    filter(isNotNullOrUndefined),
                    take(1),
                    tap(
                        c =>
                            (this.ShownCustomerContractsList = c.slice().sort((a, b) => {
                                if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                                    return -1;
                                }
                                return 1;
                            })),
                    ),
                )
                .subscribe(),
        );

    }
    public SearchContractButtonClicked() {
        if (!this.ContractSearchBarActive) {
            this.ContractSearchBarActive = true;
            setTimeout(
                () => (
                    this.contractSearchInput && this.contractSearchInput.nativeElement.focus(),
                    this.contractSearchInputEdit && this.contractSearchInputEdit.nativeElement.focus()
                ),
            );
        } else {
            if (this.ContractSearchForm.value.length === 0) {
                this.ContractSearchBarActive = false;
            }
            this.SearchContract();
        }
    }




    public SearchContract() {
        const searchTerm = this.ContractSearchForm.value.toLowerCase();

        this.ShownCustomerContractsList = this.CustomerContractList.filter(
            contract =>
                (contract.Name && contract.Name.toLowerCase().includes(searchTerm)) ||
                (contract.Number && contract.Number.toLowerCase().includes(searchTerm)),
        );
        this.ShownAllContractsList = this.allContractsList.filter(
            contract =>
                (contract.Name && contract.Name.toLowerCase().includes(searchTerm)) ||
                (contract.Number && contract.Number.toLowerCase().includes(searchTerm)),
        );
        this.cdr.detectChanges();
    }

    public ClearContractSearchForm() {
        this.ContractSearchForm.setValue('');
        this.ShownCustomerContractsList = this.CustomerContractList.sort((a, b) => {
            if (a.Number && !b.Number) {
                return 1;
            }
            return -1;
        });
        this.ShownAllContractsList = this.allContractsList.sort((a, b) => {
            if (a.Number && !b.Number) {
                return 1;
            }
            return -1;
        });
    }
    public EditContractList(contract: ContractEntity) {
        if (this.editContractIdList.find(c => c === contract.Id)) {
            this.editContractIdList = this.editContractIdList.filter(c => c !== contract.Id);
        } else {
            this.editContractIdList.push(contract.Id);
        }
    }

    // überprüft, ob für den Vertrag ein blauer Haken gezeigt werden soll
    public BlueCheck(contractId: number): boolean {
        return (
            this.CustomerContractList.find(c => c.Id === contractId) === undefined &&
            this.editContractIdList.find(c => c === contractId) !== undefined
        );
    }

    // überprüft, ob für den Vertrag ein grüner Haken gezeigt werden soll
    public GreenCheck(contractId: number): boolean {
        return (
            this.CustomerContractList.find(c => c.Id === contractId) !== undefined &&
            this.editContractIdList.find(c => c === contractId) !== undefined
        );
    }
    protected readonly CommissionMeta = CommissionMeta;
}
